'use client';
import styled from 'styled-components';
import { colors, toRgba, breakPoints } from '@/styles';

export const SourceTargetFiles = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px 5px !important;

  .title {
    font-size: 12px;
    margin-bottom: 5px;
  }

  .file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & > * {
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: hidden;
    padding: 5px 10px;
    /* &:not(:last-child) {
      border-right: 1px solid ${colors.secondary.lightGray3};
    } */
    & > * {
      display: flex;
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
    }
  }

  .source-section {
    /* max-width: calc(50% - 50px); */
  }
  .arrow-section {
    /* min-width: 50px; */
  }
  .target-section {
    /* max-width: calc(50% - 50px); */
  }
`;
